import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { checkAuth, authenticatedRequest } from '../utils/auth';
import './CreateOffer.css';

const CreateOffer = () => {
  const [formData, setFormData] = useState({
    type: '',
    adType: '',
    title: '',
    messageDescription: '',
    picture: 'uploadspublic/offers/no-offer-image.png',
    expirationDate: '',
    time: [],
    distanceLimit: '',
    restaurant: '',
    restaurantName: '',
    offerDeleteDate: ''
  });
  const [restaurants, setRestaurants] = useState([]);
  const [selectedRestaurantId, setSelectedRestaurantId] = useState('');
  const [typedRestaurantName, setTypedRestaurantName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedTimeBlocks, setSelectedTimeBlocks] = useState([]);
  const navigate = useNavigate();

  // Time blocks with flexible ranges
  const timeBlocks = [
    { id: 1, label: 'صبح', minTime: '07:00', maxTime: '11:59', startTime: '', endTime: '' },
    { id: 2, label: 'ظهر', minTime: '12:00', maxTime: '15:59', startTime: '', endTime: '' },
    { id: 3, label: 'عصر', minTime: '16:00', maxTime: '19:29', startTime: '', endTime: '' },
    { id: 4, label: 'شب', minTime: '19:30', maxTime: '23:58', startTime: '', endTime: '' }
  ];

  // Type options for dropdown
  const typeOptions = [
    'رویداد',
    'تازه',
    'پیشنهاد',
    'تفریحات',
    'آموزش',
    'سرگرمی',
    'دورهمی'
  ];

  // Ad Type options
  const adTypeOptions = [
    { value: 'dynamic', label: 'Dynamic' },
    { value: 'static', label: 'Static' }
  ];

  useEffect(() => {
    const initializeComponent = async () => {
      // Check authentication first
      const isAuthenticated = await checkAuth();
      if (!isAuthenticated) {
        setError('برای دسترسی به این بخش باید وارد شوید');
        navigate('/');
        return;
      }
      
      // If authenticated, fetch restaurants
      await fetchRestaurants();
    };
    
    initializeComponent();
  }, [navigate]);

  const fetchRestaurants = async () => {
    try {
  const response = await axios.get('https://apipublic.menuoff.com/restaurants-public');
      
      if (response.data.ok) {
        setRestaurants(response.data.restaurants);
      } else {
        console.error('Error fetching restaurants:', response.data.message);
        setError('خطا در دریافت لیست رستوران‌ها');
      }
    } catch (err) {
      console.error('Error fetching restaurants:', err);
      setError('خطا در اتصال به سرور برای دریافت رستوران‌ها');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRestaurantDropdownChange = (e) => {
    const selectedId = e.target.value;
    setSelectedRestaurantId(selectedId);
    
    if (selectedId) {
      // Find the selected restaurant to get its name
      const selectedRestaurant = restaurants.find(r => r._id === selectedId);
      const restaurantName = selectedRestaurant ? selectedRestaurant.name : '';
      
      console.log('Restaurant selected:', { selectedId, restaurantName, selectedRestaurant });
      
      // Clear typed name when dropdown is selected
      setTypedRestaurantName('');
      setFormData(prev => ({
        ...prev,
        restaurant: selectedId,
        restaurantName: restaurantName
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        restaurant: '',
        restaurantName: ''
      }));
    }
  };

  const handleTypedRestaurantChange = (e) => {
    const typedName = e.target.value;
    setTypedRestaurantName(typedName);
    
    if (typedName) {
      // Clear dropdown selection when typing
      setSelectedRestaurantId('');
      setFormData(prev => ({
        ...prev,
        restaurant: typedName,
        restaurantName: typedName
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        restaurant: '',
        restaurantName: ''
      }));
    }
  };

  
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    
    if (!file) {
      setSelectedImage(null);
      setImagePreview(null);
      return;
    }

    // Check file size (200KB = 200 * 1024 bytes)
    const maxSize = 200 * 1024;
    if (file.size > maxSize) {
      setError('حجم تصویر نباید بیشتر از 200 کیلوبایت باشد');
      e.target.value = '';
      return;
    }

    // Check file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    if (!allowedTypes.includes(file.type)) {
      setError('فقط فایل‌های تصویری (JPG, PNG, GIF) مجاز هستند');
      e.target.value = '';
      return;
    }

    setSelectedImage(file);
    setError(''); // Clear any previous errors

    // Create preview
    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const removeImage = () => {
    setSelectedImage(null);
    setImagePreview(null);
    // Clear the file input
    const fileInput = document.getElementById('picture');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const handleTimeBlockToggle = (blockId) => {
    let newSelectedBlocks;
    if (selectedTimeBlocks.some(block => block.id === blockId)) {
      // Remove block if already selected
      newSelectedBlocks = selectedTimeBlocks.filter(block => block.id !== blockId);
    } else {
      // Add block if not selected and under limit
      if (selectedTimeBlocks.length < 4) {
        const block = timeBlocks.find(b => b.id === blockId);
        newSelectedBlocks = [...selectedTimeBlocks, { ...block, startTime: block.minTime, endTime: block.maxTime }];
      } else {
        setError('حداکثر 4 بازه زمانی می‌توانید انتخاب کنید');
        return;
      }
    }

    setSelectedTimeBlocks(newSelectedBlocks);
    updateFormDataTime(newSelectedBlocks);

    // Clear error if any
    if (error.includes('بازه زمانی')) {
      setError('');
    }
  };

  const handleTimeChange = (blockId, field, value) => {
    const updatedBlocks = selectedTimeBlocks.map(block => {
      if (block.id === blockId) {
        const updatedBlock = { ...block, [field]: value };
        
        // Validate time is within block boundaries
        if (field === 'startTime' && (value < block.minTime || value > block.maxTime)) {
          setError(`زمان شروع باید بین ${block.minTime} تا ${block.maxTime} باشد`);
          return block;
        }
        if (field === 'endTime' && (value < block.minTime || value > block.maxTime)) {
          setError(`زمان پایان باید بین ${block.minTime} تا ${block.maxTime} باشد`);
          return block;
        }
        
        // Validate start time is before end time
        if (field === 'startTime' && updatedBlock.endTime && value >= updatedBlock.endTime) {
          setError('زمان شروع باید کمتر از زمان پایان باشد');
          return block;
        }
        if (field === 'endTime' && updatedBlock.startTime && value <= updatedBlock.startTime) {
          setError('زمان پایان باید بیشتر از زمان شروع باشد');
          return block;
        }
        
        // Clear error if validation passes
        if (error.includes('زمان')) {
          setError('');
        }
        
        return updatedBlock;
      }
      return block;
    });
    
    setSelectedTimeBlocks(updatedBlocks);
    updateFormDataTime(updatedBlocks);
  };

  const updateFormDataTime = (blocks) => {
  
    const timeArray = timeBlocks.map(tb => {
      const selected = blocks.find(b => b.id === tb.id);
      return {
        startTime: selected && selected.startTime ? selected.startTime : 'undefined',
        endTime: selected && selected.endTime ? selected.endTime : 'undefined'
      };
    });

    setFormData({
      ...formData,
      time: timeArray
    });
  };

  const formatDateTimeLocalToZulu = (datetimeLocal) => {
    if (!datetimeLocal) return '';

    const localDate = new Date(datetimeLocal);
    return localDate.toISOString();
  };

  const getDefaultExpirationZulu = () => {

    const now = new Date();
    const localAt2355 = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      55,
      0,
      0
    );
    return localAt2355.toISOString();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');


    if (!selectedRestaurantId && !typedRestaurantName.trim()) {
      setError('لطفاً رستوران را انتخاب کنید یا نام آن را تایپ کنید');
      setLoading(false);
      return;
    }

    try {
      // Priority: dropdown selection over typed name
      const finalRestaurantValue = selectedRestaurantId || typedRestaurantName.trim();
      

      console.log('Form data before sending:', {
        restaurant: finalRestaurantValue,
        restaurantName: formData.restaurantName,
        selectedRestaurantId,
        typedRestaurantName
      });

      // Create FormData for file upload
      const formDataToSend = new FormData();
      
      // Add all form fields
      formDataToSend.append('type', formData.type);
      formDataToSend.append('adType', formData.adType);
      formDataToSend.append('title', formData.title);
      formDataToSend.append('messageDescription', formData.messageDescription);
      const expirationToSend = formData.expirationDate
        ? formatDateTimeLocalToZulu(formData.expirationDate)
        : getDefaultExpirationZulu();
      formDataToSend.append('expirationDate', expirationToSend);
      formDataToSend.append('time', JSON.stringify(formData.time));
      formDataToSend.append('distanceLimit', formData.distanceLimit);
      formDataToSend.append('restaurant', finalRestaurantValue);
      formDataToSend.append('restaurantName', formData.restaurantName || '');
      if (formData.offerDeleteDate) {
        formDataToSend.append('offerDeleteDate', formatDateTimeLocalToZulu(formData.offerDeleteDate));
      }
      
      // Debug: Log what's being sent in FormData
      console.log('FormData contents:');
      for (let [key, value] of formDataToSend.entries()) {
        console.log(key, value);
      }
      
      // Add image if selected
      if (selectedImage) {
        formDataToSend.append('picture', selectedImage);
      } else {
        formDataToSend.append('picture', formData.picture);
      }

      const response = await authenticatedRequest('POST', '/offers', formDataToSend);

      if (response.data.ok) {
        setSuccess('آفر با موفقیت ایجاد شد!');
        setFormData({
          type: '',
          adType: '',
          title: '',
          messageDescription: '',
          picture: 'uploadspublic/offers/no-offer-image.png',
          expirationDate: '',
          time: [],
          distanceLimit: '',
          restaurant: '',
          restaurantName: '',
          offerDeleteDate: ''
        });
        setSelectedRestaurantId('');
        setTypedRestaurantName('');
        setSelectedImage(null);
        setImagePreview(null);
        setSelectedTimeBlocks([]);
      } else {
        setError(response.data.message || 'خطا در ایجاد آفر');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'خطا در اتصال به سرور');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    window.history.back();
  };

  return (
    <div className="create-offer-container">
      <div className="create-offer-card">
        <div className="create-offer-header">
          <button onClick={handleBack} className="back-button">
            <span className="back-arrow">←</span> بازگشت
          </button>
          <h2>ایجاد آفر جدید</h2>
          <p>اطلاعات آفر را وارد کنید</p>
        </div>

        <form onSubmit={handleSubmit} className="create-offer-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="type">نوع آفر:</label>
              <select
                id="type"
                name="type"
                value={formData.type}
                onChange={handleChange}
                required
              >
                <option value="">انتخاب نوع آفر</option>
                {typeOptions.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="adType">نوع تبلیغ:</label>
              <select
                id="adType"
                name="adType"
                value={formData.adType}
                onChange={handleChange}
                required
              >
                <option value="">انتخاب نوع تبلیغ</option>
                {adTypeOptions.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="title">عنوان آفر:</label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
                placeholder="عنوان آفر"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="messageDescription">توضیحات:</label>
            <textarea
              id="messageDescription"
              name="messageDescription"
              value={formData.messageDescription}
              onChange={handleChange}
              required
              placeholder="توضیحات آفر (حداکثر 100 کاراکتر)"
              rows="3"
              maxLength="100"
            />
            <div className="character-count">
              {formData.messageDescription.length}/100 کاراکتر
            </div>
          </div>

          <div className="form-group image-upload-section">
            <label htmlFor="picture">تصویر آفر:</label>
            <div className="image-upload-container">
              <input
                type="file"
                id="picture"
                name="picture"
                accept="image/*"
                onChange={handleImageChange}
                className="image-input"
              />
              <div className="image-upload-info">
                <p>حداکثر حجم: 200 کیلوبایت</p>
                <p>فرمت‌های مجاز: JPG, PNG, GIF</p>
              </div>
              
              {imagePreview && (
                <div className="image-preview-container">
                  <img 
                    src={imagePreview} 
                    alt="پیش‌نمایش تصویر" 
                    className="image-preview"
                  />
                  <button
                    type="button"
                    onClick={removeImage}
                    className="remove-image-btn"
                  >
                    حذف تصویر
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="expirationDate">تاریخ انقضا:</label>
              <input
                type="datetime-local"
                id="expirationDate"
                name="expirationDate"
                value={formData.expirationDate}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="distanceLimit">حد فاصله (متر):</label>
              <input
                type="number"
                id="distanceLimit"
                name="distanceLimit"
                value={formData.distanceLimit}
                onChange={handleChange}
                required
                placeholder="1000"
              />
            </div>
          </div>

          <div className="restaurant-section">
            <label>رستوران:</label>
            <div className="restaurant-fields">
              <div className="form-group">
                <label htmlFor="restaurant-dropdown">انتخاب از لیست:</label>
                <select
                  id="restaurant-dropdown"
                  value={selectedRestaurantId}
                  onChange={handleRestaurantDropdownChange}
                  className="restaurant-dropdown"
                >
                  <option value="">انتخاب رستوران از لیست</option>
                  {restaurants.map(restaurant => (
                    <option key={restaurant._id} value={restaurant._id}>
                      {restaurant.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="restaurant-typed">یا نام رستوران را تایپ کنید:</label>
                <input
                  type="text"
                  id="restaurant-typed"
                  value={typedRestaurantName}
                  onChange={handleTypedRestaurantChange}
                  placeholder="نام رستوران جدید را تایپ کنید"
                  className="restaurant-typed"
                />
              </div>
            </div>
            <p className="restaurant-note">
              * لطفاً یکی از گزینه‌های بالا را انتخاب کنید
            </p>
          </div>

          <div className="time-blocks">
            <label>ساعات فعال (حداکثر 4 بازه):</label>
            <div className="time-blocks-container">
              {timeBlocks.map((block) => {
                const isSelected = selectedTimeBlocks.some(b => b.id === block.id);
                const selectedBlock = selectedTimeBlocks.find(b => b.id === block.id);
                
                return (
                  <div key={block.id} className={`time-block-option ${isSelected ? 'selected' : ''}`}>
                    <div className="block-header">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => handleTimeBlockToggle(block.id)}
                          disabled={!isSelected && selectedTimeBlocks.length >= 4}
                        />
                        <span className="checkmark"></span>
                        {block.label} ({block.minTime} - {block.maxTime})
                      </label>
                    </div>
                    
                    {isSelected && selectedBlock && (
                      <div className="time-range-inputs">
                        <div className="time-input-group">
                          <label>از ساعت:</label>
                          <input
                            type="time"
                            value={selectedBlock.startTime}
                            min={block.minTime}
                            max={block.maxTime}
                            onChange={(e) => handleTimeChange(block.id, 'startTime', e.target.value)}
                            required
                          />
                        </div>
                        <div className="time-input-group">
                          <label>تا ساعت:</label>
                          <input
                            type="time"
                            value={selectedBlock.endTime}
                            min={block.minTime}
                            max={block.maxTime}
                            onChange={(e) => handleTimeChange(block.id, 'endTime', e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            
            {selectedTimeBlocks.length > 0 && (
              <div className="selected-blocks-preview">
                <p>بازه‌های انتخاب شده:</p>
                <ul>
                  {selectedTimeBlocks.map(block => (
                    <li key={block.id}>
                      {block.label}: {block.startTime} - {block.endTime}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="offerDeleteDate">تاریخ حذف (اختیاری):</label>
            <input
              type="datetime-local"
              id="offerDeleteDate"
              name="offerDeleteDate"
              value={formData.offerDeleteDate}
              onChange={handleChange}
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          {success && (
            <div className="success-message">
              {success}
            </div>
          )}

          <div className="form-actions">
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              className="cancel-button"
            >
              بازگشت
            </button>
            <button
              type="submit"
              className="submit-button"
              disabled={loading}
            >
              {loading ? 'در حال ایجاد...' : 'ایجاد آفر'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateOffer;

